/*
 * @Descripttion: 供应商订单发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 14:05:46
 */
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  EXPORT_SUPPLIER_ORDER_DETAIL,
  GET_INVOICE_SUPPLIER_ORDER_PAGE,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess } from '../../../tools/util'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

const UseSupplierInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const setSupplierInvoiceCount = useInvoiceEntryStore((state) => state.setSupplierInvoiceCount)
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 选中订单
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_INVOICE_SUPPLIER_ORDER_PAGE({
      schemeId: params.schemeId,
      receiveMan: params.receiveMan,
      supplierOrderCode: params.supplierOrderCode,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: res.data.content, total: count },
          pageNo: res.data.pageNo,
        }),
      )
      // 更新zustand store中的count值
      setSupplierInvoiceCount(count)
      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    history.push('/srm/addInvoiceEntry', {
      data: selectedRows,
      type: 'supplier',
      orderType: '1',
    })
  }

  // 打开开票提示弹窗
  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    EXPORT_SUPPLIER_ORDER_DETAIL({ orderIds: idList })
  }

  useEffect(() => {
    getPageData(state)
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  }
}

export default UseSupplierInvoiceEntryHook
/*
 * @Descripttion: 供应商订单发票录入页hooks
 * @Author: cb4786
 * @Date: 2023-08-10 17:06:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 14:05:46
 */
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  EXPORT_SUPPLIER_ORDER_DETAIL,
  GET_INVOICE_SUPPLIER_ORDER_PAGE,
} from '../../../api/orderManage'
import { history } from '../../../redux/store'
import { isResponseCodeSuccess } from '../../../tools/util'
import {
  State,
  initialState,
  reducer,
  setDataSourceAction,
  setInvoiceTipAction,
  setLoadingAction,
  setPagesAction,
  setSearchdataAction,
  setSelectedRowsAction,
} from './reducer'
import { useInvoiceEntryStore } from '@/stores/invoiceEntryStore'

const UseSupplierInvoiceEntryHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state
  const setSupplierInvoiceCount = useInvoiceEntryStore((state) => state.setSupplierInvoiceCount)
  const handlePaginationChange = async (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    await getPageData({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 选中订单
  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  // 获取列表数据
  const getPageData = async (state: State) => {
    dispatch(setLoadingAction(true))
    dispatch(setSelectedRowsAction([]))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_INVOICE_SUPPLIER_ORDER_PAGE({
      schemeId: params.schemeId,
      receiveMan: params.receiveMan,
      supplierOrderCode: params.supplierOrderCode,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
    })
    if (isResponseCodeSuccess(res.code)) {
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: res.data.content, total: count },
          pageNo: res.data.pageNo,
        }),
      )
      // 更新zustand store中的count值
      setSupplierInvoiceCount(count)
      dispatch(setLoadingAction(false))
    }
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getPageData({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 发票录入
  const handleBatchRecord = () => {
    if (selectedRows.length < 1) {
      message.warning('请先勾选可开票订单！')
      return
    }
    history.push('/srm/addInvoiceEntry', {
      data: selectedRows,
      type: 'supplier',
      orderType: '1',
    })
  }

  // 打开开票提示弹窗
  const changeInvoiceTip = (val: boolean) => {
    dispatch(setInvoiceTipAction(val))
  }

  // 明细导出
  const exportDetails = () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选需要导出明细的订单！')
      return
    }
    const idList = selectedRows.map((item) => item.id).join(',')
    EXPORT_SUPPLIER_ORDER_DETAIL({ orderIds: idList })
  }

  useEffect(() => {
    getPageData(state)
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
  }
}

export default UseSupplierInvoiceEntryHook
